import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError.ts';
import { IQuestionnaireAnswerPayload } from '../QuestionnaireAnswer.ts';
import { QuestionnaireAnswerApi } from '../../../apis/QuestionnaireAnswerApi/QuestionnaireAnswerApi.ts';

export function usePostQuestionnaireAnswer() {
    return useMutation<any, AppMedError, IQuestionnaireAnswerPayload>({
        mutationKey: [QueryKeys.questionnaireAnswer],
        mutationFn: async (variables: IQuestionnaireAnswerPayload) => {
            return QuestionnaireAnswerApi.postQuestionnaireAnswer(variables);
        },
    });
}
